var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox integral-system-config-page" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.pageLoading,
              expression: "pageLoading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "el-form",
            {
              ref: "configForm",
              staticClass: "config-form",
              attrs: {
                model: _vm.form,
                "label-position": "right",
                size: "small",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "积分到账时间：", required: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "inline-row" },
                    [
                      _c("span", [_vm._v("订单状态为已完结/部分退款后")]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "day-input",
                        attrs: { maxlength: "10", placeholder: "请输入" },
                        on: { input: _vm.onReceivedDelayDaysInput },
                        model: {
                          value: _vm.form.receivedDelayDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receivedDelayDays", $$v)
                          },
                          expression: "form.receivedDelayDays",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("天到账")]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "消耗积分商品退款是否退积分给客户：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.refundCustomerOrNot,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "refundCustomerOrNot", $$v)
                        },
                        expression: "form.refundCustomerOrNot",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "获取积分商品退款是否退积分给平台：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.refundPlatformOrNot,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "refundPlatformOrNot", $$v)
                        },
                        expression: "form.refundPlatformOrNot",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "未发货商品取消订单默认退积分给平台",
                        placement: "top",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question tip-icon" })]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "积分商城小程序展示：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.mallDisplayEnabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mallDisplayEnabled", $$v)
                        },
                        expression: "form.mallDisplayEnabled",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.mallDisplayEnabled
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "customer-form-item",
                      attrs: { label: "关联小程序客户：" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "customer-config" },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.mallCustomerScope,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mallCustomerScope", $$v)
                                },
                                expression: "form.mallCustomerScope",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("部分"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.mallCustomerScope === 1
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "customer-select",
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    remote: "",
                                    clearable: "",
                                    "reserve-keyword": "",
                                    "remote-method": _vm.searchCustomerOptions,
                                    loading: _vm.customerLoading,
                                    placeholder: "请选择关联小程序客户",
                                  },
                                  model: {
                                    value: _vm.form.mallCustomerIds,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "mallCustomerIds", $$v)
                                    },
                                    expression: "form.mallCustomerIds",
                                  },
                                },
                                _vm._l(_vm.customerOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.customerId,
                                    attrs: {
                                      label: _vm.customerOptionLabel(item),
                                      value: item.customerId,
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "积分有效期：" } }, [
                _c(
                  "div",
                  { staticClass: "inline-row validity-row" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.expiredOrNot,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expiredOrNot", $$v)
                          },
                          expression: "form.expiredOrNot",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("永久"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("有效期至"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.expiredOrNot
                      ? [
                          _c("span", [_vm._v("自积分获取后")]),
                          _vm._v(" "),
                          _c("el-input-number", {
                            staticClass: "expired-day-input",
                            attrs: {
                              min: 1,
                              max: 99999,
                              step: 1,
                              precision: 0,
                              "step-strictly": "",
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.expiredDay,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "expiredDay", $$v)
                              },
                              expression: "form.expiredDay",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("天过期")]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "积分到期提醒：" } }, [
                _c(
                  "div",
                  { staticClass: "inline-row reminder-row" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.expiryReminderEnabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expiryReminderEnabled", $$v)
                          },
                          expression: "form.expiryReminderEnabled",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("开启"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("关闭"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    [
                      _c("span", [_vm._v("积分到期前")]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "reminder-number-input",
                        attrs: {
                          min: 0,
                          max: 365,
                          precision: 0,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.expiryReminderLeadDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expiryReminderLeadDays", $$v)
                          },
                          expression: "form.expiryReminderLeadDays",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("天提醒，合并最早到期批次后")]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticClass: "reminder-number-input",
                        attrs: {
                          min: 0,
                          max: 365,
                          precision: 0,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.expiryReminderMergeDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "expiryReminderMergeDays", $$v)
                          },
                          expression: "form.expiryReminderMergeDays",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("天内到期积分")]),
                    ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", {
                staticClass: "rule-content-item",
                attrs: { label: "积分规则配置文案：" },
              }),
              _vm._v(" "),
              _c("Tinymce", {
                attrs: { height: 420, sourceType: "spu2" },
                model: {
                  value: _vm.form.integralRuleContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "integralRuleContent", $$v)
                  },
                  expression: "form.integralRuleContent",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:shopintegral:integral:config"],
                          expression: "['admin:shopintegral:integral:config']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "small",
                        loading: _vm.submitLoading,
                      },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("\n          提交\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }